import './StakeholdersTable.scss';
import { DeleteStakeholderNotifications } from './DeleteStakeholderNotifications';
import { getColumns } from './StakeholdersTableColumns';
import { MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import { noop } from '@lib/utility';
import { PaginatedTable } from '@ui/tables';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useAsyncState, useOnMount, useStakeholders } from '@hooks';
const columns = getColumns();
const getRowKey = (stakeholder) => stakeholder.stakeholderId;
export const StakeholdersTable = () => {
    const { data, isRequested } = useAsyncState(useStakeholders.selectors);
    const loadStakeholders = useAction(coreActions.requestGetCoreStakeholders);
    const deleteStakeholder = useAction(coreActions.requestDeleteCoreStakeholders);
    useOnMount(() => {
        loadStakeholders();
    });
    const resource = useMemo(() => {
        if (!data) {
            return undefined;
        }
        const stakeholders = data.filter((record) => !record.userId);
        return {
            results: stakeholders,
            totalCount: stakeholders === null || stakeholders === void 0 ? void 0 : stakeholders.length
        };
    }, [data]);
    const handleDelete = useCallback((stakeholder) => {
        deleteStakeholder({
            stakeholderIds: [stakeholder.stakeholderId]
        });
    }, [deleteStakeholder]);
    return (React.createElement(React.Fragment, null,
        React.createElement(PaginatedTable, { columns: columns, deletePrompt: MESSAGES_COPY.ARE_YOU_SURE_STAKEHOLDER, headerSize: 'small', id: 'stakeholders-table', loading: isRequested, onChange: noop, onDelete: handleDelete, resource: resource, rowKey: getRowKey, scroll: { x: 'max-content' }, sticky: true }),
        React.createElement(DeleteStakeholderNotifications, null)));
};
